import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PublicHomeState {
  articles: Array<any>;
}

const initialState: PublicHomeState = {
  articles: [],
};

const publicHomeSlice = createSlice({
  name: 'publicHome',
  initialState,
  reducers: {
    setPublicHome: (state, action: PayloadAction<PublicHomeState>) => {
      return { ...state, ...action.payload };
    },
    clearPublicHome: (state) => {
      state.articles = [];
    },
  },
});

export const { setPublicHome, clearPublicHome } = publicHomeSlice.actions;
export default publicHomeSlice.reducer;